import { get, writable } from 'svelte/store';
import { SlaughterService } from '../../services/slaughter.service';
export const filterSlaughterId = writable(0);
export const loading = writable(false);
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export async function initList(slaughterId) {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    filterSlaughterId.set(slaughterId);
    await load();
    initDetail();
}
export async function initDetail() {
    record.set({
        oid: 0,
        slaughterId: get(filterSlaughterId),
        progressive: 0,
        dailyProgressive: 0,
        //livestockUnloadId: 0,
        lotNumber: '',
        //srcSlaughterId: 0,
        //srcProductTypeId: 0,
        srcQuantity: 0,
        srcWeight: 0,
        //dstProductTypeId: 0,
        dstQuantity: 0,
        dstWeight: 0,
        //recipeId: 0,
        worked: 0,
        printed: 0
    });
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _slaughterId = get(filterSlaughterId);
        //let _pag = get(pagination)!;
        //let _resp = await SlaughterService.getSlaughterItems(_slaughterId, _pag.currentPage);
        let _resp = await SlaughterService.getSlaughterItems(_slaughterId);
        records.set(_resp.payload);
        //pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
}
export function onEdit(item) {
    // console.log("onEdit", item);
}
export async function save() {
    let _record = get(record);
    return await SlaughterService.saveSlaughterItem(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await SlaughterService.deleteSlaughterItem(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
